/**
 * The page inside a native TV app shell: web/tv/tizen (Samsung, ?shell=tizen)
 * and web/tv/webos (LG, ?shell=webos). The shell loads tv.lagking.com full
 * screen, so every page fix reaches the app with no resubmission (Cole,
 * 2026-09-26).
 *
 * Inside a shell: no Full screen button (the app is already full screen), no
 * cursor, and the remote's Back key goes up to the shell, which exits the app.
 * The page has focus, so the shell never sees the key itself.
 */

export type AppShell = 'tizen' | 'webos' | null;

/** Pure: which shell, if any, from the page's query string. */
export function appShellFrom(search: string): AppShell {
  const shell = new URLSearchParams(search).get('shell');
  return shell === 'tizen' || shell === 'webos' ? shell : null;
}

/** Back on the remote: Tizen sends keyCode 10009 ("XF86Back"), webOS 461
 * ("GoBack"). */
export function isShellBackKey(event: { keyCode?: number; key?: string }): boolean {
  return event.keyCode === 10009 || event.keyCode === 461 || event.key === 'XF86Back' || event.key === 'GoBack';
}

export const appShell: AppShell = typeof window === 'undefined' ? null : appShellFrom(window.location.search);

export function installAppShell(): void {
  if (!appShell) return;
  document.documentElement.classList.add('in-app-shell');
  window.addEventListener('keydown', (event) => {
    if (!isShellBackKey(event)) return;
    event.preventDefault();
    window.parent.postMessage({ lagking: 'back' }, '*');
  });
}
